import { render, staticRenderFns } from "./payment_methods.vue?vue&type=template&id=9dca7c80&scoped=true&"
import script from "./payment_methods.vue?vue&type=script&lang=js&"
export * from "./payment_methods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dca7c80",
  null
  
)

export default component.exports